const TABS = [
  { key: 'add',      icon: '+',  label: 'Add' },
  { key: 'summary',  icon: '▦',  label: 'Summary' },
  { key: 'settings', icon: '⚙', label: 'Settings' },
]

export default function BottomNav({ active, onChange }) {
  return (
    <div style={s.wrap}>
      {TABS.map(t => (
        <button key={t.key} style={{ ...s.btn, ...(active === t.key ? s.active : {}) }} onClick={() => onChange(t.key)}>
          <span style={{ ...s.icon, ...(active === t.key ? s.iconActive : {}) }}>
            {t.key === 'add'
              ? <span style={s.addBtn}>+</span>
              : t.icon}
          </span>
          <span style={s.label}>{t.label}</span>
        </button>
      ))}
    </div>
  )
}

const s = {
  wrap:     { position: 'fixed', bottom: 0, left: '50%', transform: 'translateX(-50%)', width: '100%', maxWidth: 480, background: '#fff', borderTop: '1.5px solid #EEEBE5', display: 'flex', padding: '8px 0 env(safe-area-inset-bottom)', zIndex: 100 },
  btn:      { flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3, border: 'none', background: 'none', cursor: 'pointer', padding: '6px 0', color: '#BBB' },
  active:   { color: '#1A1A2E' },
  icon:     { fontSize: 20, lineHeight: 1 },
  iconActive:{ color: '#1A1A2E' },
  label:    { fontSize: 10, fontWeight: 600, letterSpacing: 0.3 },
  addBtn:   { display: 'flex', alignItems: 'center', justifyContent: 'center', width: 44, height: 44, background: '#1A1A2E', color: '#E8C547', borderRadius: 14, fontSize: 28, fontWeight: 300, lineHeight: 1 },
}
